import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PlaidOnEventArgs, PlaidOnExitArgs, PlaidOnSuccessArgs } from './interfaces';
import { ICustomWindow } from './ngx-plaid-link.directive';
import {NGXLogger} from "ngx-logger";

function getWindow(): any {
  return window;
}

@Component({
  selector: "mr-ngx-plaid-link-button",
  template: `
    <button ngxPlaidLink
            [class]="className"
            [ngStyle]="style"
            [publicKey]="publicKey"
            [clientName]="clientName"
            [apiVersion]="apiVersion"
            [env]="env"
            [institution]="institution"
            [product]="product"
            [selectAccount]="selectAccount"
            [token]="token"
            [webhook]="webhook"
            [receivedRedirectUri]="receivedRedirectUri"
            [countryCodes]="countryCodes"
            (Success)="onDirectiveSuccess($event)"
            (Exit)="onDirectiveExit($event)"
            (Load)="onDirectiveLoad($event)"
            (Event)="onDirectiveEvent($event)"
            (Click)="onDirectiveClick($event)"
    >
      {{ buttonText }}
    </button>
  `,
  styles: []
})
export class NgxPlaidLinkButtonComponent {

  @Input() clientName: string = "";
  @Output() Event: EventEmitter<PlaidOnEventArgs> = new EventEmitter();
  @Output() Success: EventEmitter<PlaidOnSuccessArgs> = new EventEmitter();
  @Output() Click: EventEmitter<any> = new EventEmitter();
  @Output() Load: EventEmitter<any> = new EventEmitter();
  @Output() Exit: EventEmitter<PlaidOnExitArgs> = new EventEmitter();
  private defaultProps = {
    apiVersion: "v2",
    env: "sandbox",
    institution: null,
    selectAccount: false,
    token: null,
    publicKey: null,
    webhook: "",
    product: ["auth"],
    countryCodes: ["US"],
    style: {},
    buttonText: "Log In To Your Bank Account",
    className: "btn btn-primary",
    receivedRedirectUri: null,
    isWebview: false
  };
  @Input() publicKey?: string = this.defaultProps.publicKey!;
  @Input() apiVersion?: string = this.defaultProps.apiVersion;
  @Input() env?: string = this.defaultProps.env;
  @Input() institution?: string = this.defaultProps.institution!;
  @Input() product?: Array<string> = this.defaultProps.product;
  @Input() selectAccount?: boolean = this.defaultProps.selectAccount;
  @Input() token?: string = this.defaultProps.token!;
  @Input() webhook?: string = this.defaultProps.webhook;
  @Input() countryCodes?: string[] = this.defaultProps.countryCodes;
  @Input() style?: any = this.defaultProps.style;
  @Input() buttonText?: string = this.defaultProps.buttonText;
  @Input() className?: string = this.defaultProps.className;
  @Input() receivedRedirectUri?: string = this.defaultProps.receivedRedirectUri!;
  @Input() isWebview?: boolean = this.defaultProps.isWebview;

  constructor(private logger: NGXLogger) {}

  get nativeWindow(): ICustomWindow {
    return getWindow();
  }

  onScriptError() {
    this.logger.error("There was an issue loading the link-initialize.js script");
  }

  onDirectiveSuccess(event: PlaidOnSuccessArgs) {
    this.Success.emit(event);
  }

  onDirectiveExit(event: PlaidOnExitArgs) {
    this.Exit.emit(event);
  }

  onDirectiveLoad(event: any) {
    this.Load.emit(event);
  }

  onDirectiveEvent(event: PlaidOnEventArgs) {
    this.Event.emit(event);
  }

  onDirectiveClick(event: any) {
    this.Click.emit(event);
  }
}
